var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 270,
    viewBox: "0 0 188 270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 188,
    height: 270,
    rx: 12,
    fill: "#C4C4C4",
    fillOpacity: 0.52
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126.802 114.651C126.407 113.168 125.634 111.816 124.559 110.73C123.485 109.643 122.147 108.862 120.68 108.463C115.279 107 93.6245 107 93.6245 107C93.6245 107 71.9695 107 66.5692 108.463C65.1018 108.862 63.764 109.643 62.6896 110.73C61.6151 111.816 60.8418 113.168 60.4471 114.651C59 120.111 59 131.5 59 131.5C59 131.5 59 142.89 60.4471 148.348C60.8418 149.832 61.6151 151.184 62.6895 152.27C63.764 153.356 65.1018 154.138 66.5692 154.537C71.9695 156 93.6245 156 93.6245 156C93.6245 156 115.279 156 120.68 154.537C122.147 154.138 123.485 153.356 124.559 152.27C125.634 151.184 126.407 149.832 126.802 148.348C128.249 142.889 128.249 131.5 128.249 131.5C128.249 131.5 128.249 120.111 126.802 114.651Z",
    fill: "#282828"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7241 140.793V120.518L104.621 130.656L87.7241 140.793Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefVideo);
export default __webpack_public_path__ + "static/media/def_video.03780a213104d7d0c609ba4600f198bb.svg";
export { ForwardRef as ReactComponent };